// extracted by mini-css-extract-plugin
export var infoItem = "_tv-2";
export var title = "_tv-0";
export var value = "_tv-1";